var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "s-label b-m-t-u" },
    [
      _vm._t("default"),
      _vm.required
        ? _c("span", { staticClass: "s-label__required color--status-error" }, [
            _vm._v("*"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }